export const DELETE_ADDRESS_REQUEST = "DELETE_ADDRESS_REQUEST";
export const DELETE_ADDRESS_SUCCESS = "DELETE_ADDRESS_SUCCESS";
export const DELETE_ADDRESS_FAILURE = "DELETE_ADDRESS_FAILURE";

export const GET_ALL_ADDRESS_REQUEST = "GET_ALL_ADDRESS_REQUEST";
export const GET_ALL_ADDRESS_SUCCESS = "GET_ALL_ADDRESS_SUCCESS";
export const GET_ALL_ADDRESS_FAILURE = "GET_ALL_ADDRESS_FAILURE";
